/*
 * Lib Module Utils
 */

Lib.Util = (function() {

    var self = {};

    $(Lib).on('after.document.ready', function() {
        self.removeUnderscoreEqualUnderscoreHash();
    });

    /**
     * Remove #_=_ from the url, because facebook adds this to prevent auth token stealing after 302 redirect
     * http://stackoverflow.com/questions/7131909/facebook-callback-appends-to-return-url
     */
    self.removeUnderscoreEqualUnderscoreHash = function() {
        if (window.location.hash && window.location.hash === '#_=_') {
            if (window.history && history.pushState) {
                window.history.pushState('', document.title, window.location.pathname);
            }
        }
    };

    /**
     * Redirect to another page
     * @param url
     * @param full
     * @param loader
     * @param new_tab
     */
    self.redirect = function(url, full, loader, new_tab) {

        // Defaults
        full = full || false;
        loader = loader || false;
        new_tab = new_tab || false;

        // If we want a loader, show it
        if (loader) {
            Lib.Loader.show();
        }

        url = Lib.Format.url(url, full);

        if (new_tab) {
            return window.open(url, '_blank');
        }

        // Launch
        window.location.href = Lib.Format.url(url, full);
        return window;
    };

    /**
     * Convenient function to reload the page, forcefully
     */
    self.reload = function(loader) {

        // If we want a loader, show it
        if (loader) {
            Lib.Loader.show();
        }

        window.location.reload(true);
    };

    /**
     * Convenient function to get lib options
     * @param path
     * @returns {*}
     */
    self.getOption = function(path) {
        return Lib.Hash.get(Lib, 'options.' + path, null);
    };

    var ajaxDisabled = false;

    /**
     * Prevent future ajax requests through jQuery to launch
     */
    self.preventFutureAjaxRequests = function() {
        ajaxDisabled = true;
    };

    /**
     * Re-enable future ajax requests
     */
    self.enableFutureAjaxRequests = function() {
        ajaxDisabled = false;
    };

    $(document).ajaxSend(function(e, xhr) {
        if (ajaxDisabled) {
            xhr.abort();
        }
    });

    self.textAtCaret = function(textarea, text) {
        if (textarea instanceof $ && textarea.length) {
            let caretPos = textarea[0].selectionStart;
            let textAreaTxt = textarea.val();
            if (caretPos === 0 && textAreaTxt.length) {
                caretPos = textAreaTxt.length;
            }
            textarea.val(textAreaTxt.substring(0, caretPos) + text + textAreaTxt.substring(caretPos));
            Lib.Textarea.updateAutosize(textarea);
            let newCaretpos = caretPos + text.length;
            textarea[0].setSelectionRange(newCaretpos, newCaretpos + 1);
        } else {
            Lib.Debug.warn('Trying to insert text into a textarea, but no jquery textarea provided');
        }
    };

    self.guid = function(iterations) {
        iterations = iterations || 8;
        var guid = [];
        for (var i = 1; i <= iterations; i++) {
            guid.push(Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1));
        }
        return guid.join('-');
    };

    self.loadScript = function(url, callback) {

        var script = document.createElement('script');
        script.type = 'text/javascript';

        if (script.readyState) {  //IE
            script.onreadystatechange = function() {
                if (script.readyState === 'loaded' ||
                    script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  //Others
            script.onload = function() {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    };

    self.arrayUnique = function(array) {
        return array.filter(function(el, index, arr) {
            return index === arr.indexOf(el);
        });
    };

    return self;

})();
